import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="py-4 bg-[#16171E] rounded-lg shadow relative md:py-8 ">
      <div className="w-[90%] m-auto xl:flex xl:items-center xl:justify-between">
        <Link to="/" className="flex items-center mb-4 xl:mb-0">
        </Link>
        <ul className="flex flex-wrap items-center mb-6 text-sm sm:mb-0 text-gray-400 text-white">
          <li>
            <Link
              to="/gpa"
              className="mr-4 hover:underline text-white md:mr-6 "
            >
              <strong>GPA 2019</strong>
            </Link>
          </li>
          <li>
            <Link
              to="/gpa1"
              className="mr-4 hover:underline text-white md:mr-6 "
            >
              <strong>GPA 2023</strong>
            </Link>
          </li>
          <li>
            <Link
              to="/cgpa"
              className="mr-4 hover:underline text-white md:mr-6"
            >
              <strong>CGPA Calculator</strong>
            </Link>
          </li>
          <li>
            <Link
              to="/about"
              className="mr-4 hover:underline text-white md:mr-6 "
            >
              <strong>About</strong>
            </Link>
          </li>
          {/* <li>
            <Link
              to="/attendence"
              className="mr-4 hover:underline hover:text-white md:mr-6 "
            >
              Attendance Calculator
            </Link>
          </li> */}
          {/* <li>
            <a
              href="http://coe1.annauniv.edu/home/students_corner.php"
              rel="noreferrer"
              target="_blank"
              className="mr-4 hover:underline hover:text-white md:mr-6 "
            >
              Results
            </a>
          </li> */}
          <li>
            {/* <Link
              to="/syllabus"
              className="mr-4 hover:underline hover:text-white md:mr-6 "
            >
              Syllabus
            </Link> */}
          </li>
          {/* <li>
            <Link
              to="/collegereview"
              className="mr-4 hover:underline hover:text-white md:mr-6 "
            >
              College Review
            </Link>
          </li> */}
          {/* <li>
                        <Link to="#" className="hover:underline hover:text-white">Contact</Link>
                    </li> */}
        </ul>
      </div>
      <div className="w-[90%] m-auto">
        <hr className="my-6 sm:mx-auto border-gray-700 lg:my-8" />
      </div>
      <div className="text-center mt-3 font-bold" style={{ fontSize: '15px', letterSpacing: '1px', color: '#c9d2e1' }}>
                sonacgpa.vercel.app &nbsp;·&nbsp; Created by Aravinth R (CSE '22-26)
      </div>
      <span className="w-[90%] m-auto block text-sm sm:text-center ">
        © 2026{" "}
        <Link to="/" className="hover:underline text-white">
          
        </Link>
        . All Rights Reserved.
      </span>
    </footer>
    );
    };

export default Footer;
